import "../../../App.css";
import Listdelete from "./ListDelete";
import Add from "./Add";

function Experience(props) {
  const { visible, moamad, counter, setCounter } = props;
  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible) return;
  return (
    <>
      <Add increment={increment} counter={counter} moamad={moamad} />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        moamad_id={moamad.id}
      />
    </>
  );
}

export default Experience;
